import { Component, Input, OnInit, Inject } from "@angular/core";
import { FormGroup, FormArray, FormControl } from "@angular/forms";
import { PollinationInstructionsFormModel } from "../../../services/request-form.service";
import { AsEnumerable, asEnumerable } from "linq-es2015";
import { ConjunctionEnum } from "../../../../shared/models/conjunction.enum";
import { PollinationStakeLabelService, PollinationStakeLabelItemData } from "../../../../shared/services/pollination-stake-label.service";
import { CE_REQUEST_OPTIONS, ResolvedRequestOptionsService } from "../../../services/resolved-request-options";

@Component({
  selector: "app-pollination-stake-label",
  templateUrl: "./pollination-stake-label.component.html"
})
export class PollinationStakeLabelComponent implements OnInit {
  @Input() pollinationInstructions: FormGroup;

  public stakeLabel: string = "";

  public get pollinationPreferences() {
    return <FormArray>this.pollinationInstructions.get("pollinationPreferences");
  }

  public get pollinationCategory() {
    return <FormControl>this.pollinationInstructions.get("pollinationCategory");
  }

  constructor(
    private stakeLabelService: PollinationStakeLabelService,
    @Inject(CE_REQUEST_OPTIONS) private routeData: ResolvedRequestOptionsService
  ) { }

  public ngOnInit(): void {
    this.updateStakeLabel();

    this.pollinationInstructions
      .valueChanges
      .subscribe(() => {
        this.updateStakeLabel();
      })
  }

  private updateStakeLabel(): void {
    const instructions = this.pollinationInstructions.value as PollinationInstructionsFormModel;
    const items = this.getStakeLabelItemData(instructions);

    const pollinationCategoryId = instructions.pollinationCategory;

    if (!pollinationCategoryId) {
      this.stakeLabel = this.stakeLabelService.createStakeLabel(items, null, null);
      return;
    }

    const category = this.routeData.requestOptions.pollinationCategories.find(c => c.id === pollinationCategoryId);
    const pollinationCategoryName = category ? category.name : null;

    this.stakeLabel = this.stakeLabelService.createStakeLabel(items, pollinationCategoryId, pollinationCategoryName);
  }

  private getStakeLabelItemData(instructions: PollinationInstructionsFormModel): PollinationStakeLabelItemData[] {
    const preferenceGroups = instructions.pollinationPreferences;
    const hasCategory = instructions.pollinationCategory != null;
    
    return AsEnumerable(preferenceGroups)
      .SelectMany((g, groupIndex) =>
        asEnumerable(g.items)
          .Select((i, itemIndex) => <PollinationStakeLabelItemData>{
            groupIndex: groupIndex,
            groupConjunction: this.stakeLabelService.getGroupConjunction(groupIndex, g.conjunction, hasCategory),
            itemIndex: itemIndex,
            itemConjunction: itemIndex === 0 ? "" : (i.conjunction === ConjunctionEnum.And ? "&" : "/"),
            pollinationType: i.pollinationType,
            geName: i.geName,
            truncatedPollinationType: ""
          })
      )
      .ToArray();
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/pollination-instructions/pollination-stake-label/pollination-stake-label.component.ts